import { hca_permissions, environment, script_faq } from '../../userManager/settings';
import { requestWithHeaders } from '../../helpers/request'

function startNewChat() {
  const root = document.createElement('div');
  root.id = 'hca_chat_root';
  const script = document.createElement('script');
  script.src = script_faq;
  script.type = 'text/javascript';
  script.async = true;
  script.onload = () => {
    if (window.customerServiceLoader) {
      if (window.customerServiceLoader.customerLoader) {
        const loader = window.customerServiceLoader.customerLoader;
        try {
          loader('hca_chat', environment);
        } catch (error) {
          console.log("🚀 ~ error load hca chat:", error);
          throw new Error("Error on Start New Chat");
        }
      }
    }
  };

  document.head.appendChild(script);
  document.body.appendChild(root);
}

function startElevio() {
  // inject faq
  const script = document.createElement('script');
  script.src = script_faq;
  script.type = 'text/javascript';
  script.async = true;
  script.onload = () => {
    if (window.customerServiceLoader) {
      if (window.customerServiceLoader.customerLoader) {
        const loader = window.customerServiceLoader.customerLoader;
        try {
          loader('hub', environment);
        } catch (error) {
          console.log("🚀 ~ error load elevio:", error);
          throw new Error("Error on FAQ");
        }
      }
    }
  };

  document.head.appendChild(script);
}

function handleStartWidget(user) {
    window.dataLayer = window.dataLayer || [];
    requestWithHeaders({
      url: `${hca_permissions}advisors/permissions?feature=Chat`,
      headers: {
        auth: `Bearer ${user.access_token}`,
        'Access-Control-Allow-Headers': '*'
      }
    })
    .then((response) => JSON.parse(response))
    .then((response) => response.result[0].enabled ? startNewChat() : startElevio())
    .catch((error) => {
      console.log(error);
      startElevio();
    });
}

export default function (user) {
  try {
    console.log('[faq-index] started');
    if (document.readyState !== 'loading') {
      console.log('[faq-index] document is already ready');
      handleStartWidget(user);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        console.log('[faq-index] domContentLoaded executed');
        handleStartWidget(user);
      });
    }
  } catch (err) {
    console.log("🚀 ~ error load permissions faq:", err);
  }  
}
